<div class="mb-4">
  @if(label){
  <label class="field-label">
    {{ label }}
    @if (isRequired) {
      <span class="text-red-600" aria-hidden="true">*</span>
    }
  </label>
  @if (otherInfo) {
  <p class="text-dc-navy! mb-2">{{ otherInfo }}</p>
  } }
  <div class="space-y-2">
    @for (option of options; track option) {
    <label class="flex items-center gap-x-2 cursor-pointer relative">
      <input
        type="checkbox"
        [checked]="isChecked(option.value)"
        (change)="onCheckboxChange(option.value, $event)"
        [disabled]="disabled"
        class="peer form-checkbox h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy rounded-none disabled:cursor-not-allowed"
      />
      @if (isChecked(option.value)) {
        <span
          class="h-6 w-6 font-sans text-white text-sm text-center pt-0.25 absolute bg-white border border-dc-navy peer-checked:bg-dc-navy peer-disabled:bg-gray-200 peer-disabled:border-gray-300"
        >
          <i class="fas fa-check"></i>
        </span>
      }
      <span class="text-sm text-dc-navy">
        {{ option?.label }}
        @if (isRequired && options.length === 1) {
          <span class="text-red-600" aria-hidden="true">*</span>
        }
      </span>
    </label>
    }

    <div class="fields-error-container">
      <!-- Show custom error messages -->
      @if (control.touched && control.invalid) { @for (errorKey of errorKeys;
      track errorKey) { @if (control.hasError(errorKey)) {
      {{
        validationMessages[errorKey] ||
          (errorKey === "required" || errorKey === "requiredTrue"
            ? ("VALIDATION_MSG.FIELD_REQUIRED" | translate)
            : "Invalid value")
      }}
      <br />
      } } }
    </div>
  </div>
</div>
